import { Alert, Box, Button, Flex, Typography } from '@ergolabs/ui-kit';
import React, { FC } from 'react';

import { disconnectWallet } from '../../../../../../../api/wallet/wallet';

export const NoAddressMessage: FC = () => (
  <Box borderRadius="l" padding={4}>
    <Flex col>
      <Flex.Item marginBottom={6}>
        <Alert
          type="warning"
          showIcon
          message={
            <Typography.Body>
              None of your addresses are in the Spectrum Finance community
              snapshot. Wait for the “Public round” or try another wallet. If
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              you believe there is a mistake, don't hesitate to reach out to us
              in the Discord community for assistance.
            </Typography.Body>
          }
        />
      </Flex.Item>
      <Flex.Item marginBottom={2} width="100%">
        <Button
          type="primary"
          size="large"
          htmlType="button"
          width="100%"
          href="https://discord.com/invite/zY2gmTYQVD"
          target="_blank"
        >
          Contact us
        </Button>
      </Flex.Item>
      <Flex.Item width="100%">
        <Button
          size="large"
          htmlType="button"
          onClick={disconnectWallet}
          width="100%"
        >
          Disconnect wallet
        </Button>
      </Flex.Item>
    </Flex>
  </Box>
);
